import MuiSkeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

export const Root = styled(MuiSkeleton)({});
